import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "fpx-button",
  templateUrl: "./fpx-button.component.html",
  styleUrls: ["./fpx-button.component.scss"],
})
export class FpxButtonComponent implements OnInit {
  @Output() onClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output() onDbClick: EventEmitter<MouseEvent> =
    new EventEmitter<MouseEvent>();

  @Input() label: string = "";
  @Input() className: string = "";
  @Input() btnType: "submit" | "reset" | "button" = "button";
  @Input() disable: boolean = false;
  constructor() {}

  ngOnInit(): void {}

  onBtnClick(event: MouseEvent) {
    event?.stopPropagation();
    event?.preventDefault();
    this.onClick.emit(event);
  }

  onBtnDoubleClick(event: MouseEvent) {
    event?.stopPropagation();
    event?.preventDefault();
    this.onDbClick.emit(event);
  }
}
